module.exports = __webpack_public_path__ + "static/media/vic-boat.40118358.png";